"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ChangeUpIcon_svg_1 = __importDefault(require("../../assets/images/ChangeUpIcon.svg"));

var ChangeDownIcon_svg_1 = __importDefault(require("../../assets/images/ChangeDownIcon.svg"));

exports.overviewAssets = {
  changeIndicator: {
    changeUpIcon: ChangeUpIcon_svg_1.default,
    changeDownIcon: ChangeDownIcon_svg_1.default
  }
};